import { useStoreConfig } from '@/stores/app/config';
import { useStoreSystem } from '@/stores/system';

export default function useAppConfigStore() {
    const config = useStoreConfig();
    const system = useStoreSystem();

    const canAsyncData = (store: any) => {
        return (!store.loaded || system.route.changed) || config.debug.fetchServer;
    };
    const canAsyncDataLoaded = (notLoaded: boolean) => {
        return (notLoaded || system.route.changed) || config.debug.fetchServer;
    };

    return {
        canAsyncData,
        canAsyncDataLoaded,
    };
}
